import React from 'react';
import { Box, Button, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { NavigationProps } from '../types';

export const Navigation: React.FC<NavigationProps> = ({
  onNext,
  onBack,
  onComplete,
  canGoBack,
  canGoNext,
  canComplete,
  isSubmitting = false,
  language,
}) => {
  const getNextButtonText = (): string => {
    return language === 'no' ? 'Neste' : 'Next';
  };

  const getCompleteButtonText = (): string => {
    return language === 'no' ? 'Fullfør' : 'Complete';
  };

  const getBackButtonLabel = (): string => {
    return language === 'no' ? 'Tilbake' : 'Back';
  };

  const handleNextClick = () => {
    if (canGoNext && !isSubmitting) {
      onNext();
    }
  };

  const handleCompleteClick = () => {
    if (canComplete && !isSubmitting) {
      onComplete();
    }
  };

  const handleBackClick = () => {
    if (canGoBack && !isSubmitting) {
      onBack();
    }
  };

  return (
    <Box
      className="survey-navigation"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        maxWidth: 500,
        pt: 4,
        pb: 2, // Add padding bottom for better spacing
      }}
    >
      {/* Back button */}
      {canGoBack ? (
        <IconButton
          onClick={handleBackClick}
          disabled={isSubmitting}
          aria-label={getBackButtonLabel()}
          data-testid="back-button"
          size="large"
        >
          <ArrowBack />
        </IconButton>
      ) : (
        <Box />
      )}

      {/* Next or Complete button */}
      {canComplete ? (
        <Button
          variant="contained"
          size="large"
          onClick={handleCompleteClick}
          disabled={!canComplete || isSubmitting}
          data-testid="complete-button"
          sx={{ px: 4 }}
        >
          {getCompleteButtonText()}
        </Button>
      ) : (
        <Button
          variant="contained"
          size="large"
          onClick={handleNextClick}
          disabled={!canGoNext || isSubmitting}
          data-testid="next-button"
          sx={{ px: 4 }}
        >
          {getNextButtonText()}
        </Button>
      )}
    </Box>
  );
};
